import { useMutation } from "@tanstack/react-query";
import { Fragment, useMemo, useState } from "react";
import { Col, Table } from "react-bootstrap";
import { BiCheck } from "react-icons/bi";
import Swal from "sweetalert2";
import LoadingButton from "../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../function/helper";
import useSharedData from "../../../hooks/useSharedData";
import PayLinkCheckoutModal from "./PayLinkCheckoutModal";

export default function PayLinkCheckoutButton({ orders }) {
  const { isAuthed, user } = useSharedData();
  const [show, setShow] = useState(false);

  const { isPending, mutate } = useMutation({
    mutationKey: ["PayLinkCheckoutButton"],
    mutationFn: body =>
      postRequestByAuth("/totalpost/v1/payLink/pay", body).then(res => {
        if (res && res.status === 200) {
          window.location.href = res.data.redirect;
          return;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          confirmButtonColor: "red",
          confirmButtonText: "متوجه شدم",
        });
      }),
  });

  const amount = useMemo(() => {
    return orders.reduce((sum, item) => item.realPayable + sum, 0);
  }, []);

  const submit = (body = null) => {
    if (!body) {
      mutate({
        mobile: user.phone,
        numberParcels: orders.map(item => item.numberParcel),
      });
      return;
    }

    mutate({
      ...body,
      numberParcels: orders.map(item => item.numberParcel),
    });
  };

  return (
    <Fragment>
      <h5 className="mt-4 mb-3">اطلاعات پرداخت</h5>

      <div className="card-shadow rounded-1 p-4 ">
        <p className="d-flex justify-content-center align-items-center gap-2">
          <span>مجموع مبلغ قابل پرداخت: </span>
          <strong className="fs-5 text-purple">
            {amount.toLocaleString()}
          </strong>
          <span> ریال</span>
        </p>

        <Col xs={12} md={10} className="mx-auto overflow-x-auto my-3">
          <Table bordered className="table-center">
            <thead>
              <tr>
                <th>بارکد پستی</th>
                <th>پیامک</th>
                <th>جمع آوری</th>
                <th>بسته بندی</th>
                <th style={{ minWidth: 180 }}>خدمات نمایندگی در مبدا</th>
                <th>پرینت فاکتور</th>
                <th>بیمه</th>
                <th>مالیات</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <BiCheck size="28" />
                </td>

                <td>
                  {orders.find(item => item.hasSMS === true) && (
                    <BiCheck size="28" />
                  )}
                </td>

                <td>
                  {orders.find(item => item.hasCollecting === true) && (
                    <BiCheck size="28" />
                  )}
                </td>

                <td>
                  {orders.find(item => item.hasPackaging === true) && (
                    <BiCheck size="28" />
                  )}
                </td>

                <td>
                  {orders.find(item => item.hasServiceInPlace === true) && (
                    <BiCheck size="28" />
                  )}
                </td>

                <td>
                  {orders.find(item => item.hasPrint === true) && (
                    <BiCheck size="28" />
                  )}
                </td>

                <td>
                  <BiCheck size="28" />
                </td>
                <td>
                  <BiCheck size="28" />
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>

        <div className="d-flex justify-content-center">
          <LoadingButton
            center
            className="btn-purple"
            isLoading={isPending}
            title={isPending ? "در حال انتقال" : "پرداخت از طریق درگاه بانکی"}
            onClick={isAuthed ? () => submit() : () => setShow(true)}
          />
        </div>
      </div>

      {show && (
        <PayLinkCheckoutModal
          onClose={() => setShow(false)}
          onSubmit={submit}
          isPending={isPending}
        />
      )}
    </Fragment>
  );
}
